import React from 'react';
import { Button, Form, Row, Col } from 'antd';
import { InputField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

export default (props) => {
  const { searchVal } = props;
  const { control, handleSubmit } = useForm()
  const i18n = useTranslate();
  const { t } = i18n;

  const onSubmit = (val) => {
    props.onSearch(val);
  }

  return (
    <Form onFinish={handleSubmit(onSubmit)} layout="inline" className='w-100 inline-form'>
      <Row className='w-100' gutter={[10, 10]}>
        <Col flex="auto">
          <InputField
            fieldname='store_name'
            label=''
            class='mb-0 w-100'
            initValue={searchVal?.store_name ? searchVal?.store_name : ''}
            control={control}
            iProps={{ placeholder: `${t("General.search_by_name")}..` }}
          />
        </Col>
        <Col flex="auto">
          <InputField
            fieldname='email'
            label=''
            class='mb-0 w-100'
            initValue={searchVal?.email ? searchVal?.email : ''}
            control={control}
            iProps={{ placeholder: `${t("General.search_by_email")}..` }}
          />
        </Col>
        <Col flex="70px">
          <Button className='w-100' size='large' type='primary' htmlType='submit'>{t("General.search")}</Button>
        </Col>
      </Row>
    </Form>
  )
}